module.exports = __webpack_public_path__ + "static/media/activity-status-pattern.e1748671.svg";